<div class="card">
	<div class="card-header bg-theme">
		<h5 class="card-title pt-1 text-light mb-0">
			{{getFileName()}}
			<button class="btn btn-sm btn-light float-end" (click)="copyLink()">Copy File Link</button>
		</h5>
	</div>
	<div class="card-body" style="overflow:auto">
		<img *ngIf="fileUrl && isImage" [src]="fileUrl" />
		<pdf-viewer *ngIf="fileUrl && isPdf" [src]="fileUrl" [render-text]="true" [original-size]="true"
			[show-borders]="true" style="width: 100%;"></pdf-viewer>
	</div>
</div>